import { useEffect } from 'react';
import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

export const appConfigState = atom({
  key: 'appConfiguration',
  default: {
    locale: 'en-GB',
  },
});

/**
 * useAppConfig
 * @description get application configuration
 * @returns {Object} appConfig
 *          {string} appConfig.locale
 *          {string} appConfig.agentLib
 *          {string} appConfig.serviceUrl
 *          {string} appConfig.businessArea
 *          {string} appConfig.channel
 *          {string} appConfig.messagingStatus
 *          {boolean} appConfig.chatbot
 */
export const useAppConfig = () => useRecoilValue(appConfigState);

export const useFetchAppConfig = () => {
  const setAppConfig = useSetRecoilState(appConfigState);

  useEffect(() => {
    setAppConfig((prevAppConfig) => ({
      ...prevAppConfig,
      ...(window.utag_data?.hsbc_chat_assistant_config ?? {}),
      countryCode: window.utag_data?.['dtc_va_country'],
    }));
  }, [setAppConfig]);
};
